import { inject } from '@angular/core';
import { TeacherApiService, ClusterApiService } from '@shared/services';
import { FormConfig } from '../edit-create-form.interfaces';
import { CLUSTER_SELECT_CONFIG, TEACHER_SELECT_CONFIG } from '@shared/components/generic-select/generic-select.configs';

export const teacherClusterHistoryFormConfig = (): FormConfig => {
  const teacherApiService = inject(TeacherApiService);
  const clusterApiService = inject(ClusterApiService);

  return {
    fields: [
      {
        key: 'id', label: 'ID', type: 'text', width: 'full', hidden: true
      },
      {
        key: 'teacherId', label: 'Giáo viên', required: true, width: 'full',
        type: 'select', config: { ...TEACHER_SELECT_CONFIG, service: teacherApiService },
        disabled: (editMode) => editMode
      },      
      {
        key: 'clusterId', label: 'Cụm', required: true, width: '1/4',
        type: 'select', config: { ...CLUSTER_SELECT_CONFIG, service: clusterApiService }
      },
      {
        key: 'available', label: '\u00A0', required: false, width: '1/4',
        type: 'toggleSwitch', placeholder: 'Có sẵn', labelPosition: 'default'
      },
      {
        key: 'fromDate', label: 'Từ ngày', required: true, width: '1/2',
        type: 'datepicker', placeholder: 'Chọn ngày bắt đầu'
      },
      {
        key: 'note', label: 'Ghi chú', required: false, width: 'full',
        type: 'textarea', placeholder: 'Nhập ghi chú'
      }
    ]
  };
};
